var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridCross2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    opacity: 1,
    width: 800,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2,
    stroke: "hsl(39.4,100%,93.7%)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: -0.2,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: -16.666666666666668,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 66.16666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 50,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 132.83333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 116.66666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 199.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 183.33333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 266.1666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 250.00000000000003,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 332.83333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 316.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 399.50000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 383.33333333333337,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 466.16666666666674,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 450.00000000000006,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 532.8333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 516.6666666666667,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 599.5,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 583.3333333333334,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 666.1666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 650,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 732.8333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 716.6666666666666,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: -16.666666666666668,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: -0.2,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 0, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 50,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 66.16666666666667,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 66.66666666666667, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 116.66666666666667,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 132.83333333333334,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 133.33333333333334, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 183.33333333333334,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 199.5,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 200, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 250.00000000000003,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 266.1666666666667,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 266.6666666666667, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 316.6666666666667,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 332.83333333333337,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 333.33333333333337, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 383.33333333333337,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 399.50000000000006,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 400.00000000000006, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 450.00000000000006,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 466.16666666666674,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 466.66666666666674, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 516.6666666666667,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 532.8333333333334,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 533.3333333333334, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 583.3333333333334,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 599.5,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 600, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 650,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 666.1666666666666,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 666.6666666666666, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 716.6666666666666,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 732.8333333333333,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 733.3333333333333, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.333333333333336,
    height: 1,
    x: 783.3333333333333,
    y: 799.4999999999999,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33.333333333333336,
    x: 799.4999999999999,
    y: 783.3333333333333,
    stroke: "none",
    fill: "hsl(39.4,100%,93.7%)",
    rx: 0.2,
    transform: "rotate(45, 799.9999999999999, 799.9999999999999)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridCross2);
export default __webpack_public_path__ + "static/media/grid_cross2.62b6b6ad7f3df3f78a3e13ca861ce73d.svg";
export { ForwardRef as ReactComponent };